import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export type MigrationType = 'code_migration' | 'db_migration'

export interface ProjectState {
  selectedProjectId: string | null
  selectedProjectName: string | null   // exact project_name string used by backend
  selectedFileIds: string[]
  migrationType: MigrationType
}

const initialState: ProjectState = {
  selectedProjectId: null,
  selectedProjectName: null,
  selectedFileIds: [],
  migrationType: 'code_migration',
}

export const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    setSelectedProject: (
      state,
      action: PayloadAction<{ id: string; name: string }>
    ) => {
      state.selectedProjectId = action.payload.id
      state.selectedProjectName = action.payload.name
      state.selectedFileIds = []
      state.migrationType = 'code_migration'
    },
    clearSelectedProject: (state) => {
      state.selectedProjectId = null
      state.selectedProjectName = null
      state.selectedFileIds = []
      state.migrationType = 'code_migration'
    },
    setSelectedFileIds: (state, action: PayloadAction<string[]>) => {
      state.selectedFileIds = action.payload
    },
    setMigrationType: (state, action: PayloadAction<MigrationType>) => {
      state.migrationType = action.payload
    },
  },
})

export const { setSelectedProject, clearSelectedProject, setSelectedFileIds, setMigrationType } =
  projectSlice.actions
export default projectSlice.reducer
